import _concat from 'lodash/concat';
import _filter from 'lodash/filter';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import _reduce from 'lodash/reduce';
import _uniqBy from 'lodash/uniqBy';

/**
* Utils
*/
const antipassbackScenarioTriggersFromType = (scenarios, triggerType) => (
  _uniqBy(
    _reduce(scenarios, (result, scenario) => {
      const filteredScenarioTriggers = _filter(scenario.scenario_triggers, ['type', triggerType]);
      if (!_isEmpty(filteredScenarioTriggers)) {
        return _concat(
          result, _map(filteredScenarioTriggers, (scenarioTrigger) => ({
            device_id: scenario.device_id,
            ...scenarioTrigger,
          })),
        );
      }
      return result;
    }, []), 'trigger_id',
  )
);

/**
* Model
*/
const antipassback = {
  // Name
  name: 'antipassback',

  // Utils
  scenarioTriggersFromType: antipassbackScenarioTriggersFromType,
};

module.exports = antipassback;



// WEBPACK FOOTER //
// ./models/antipassback.js